<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <div class="page-wrapper">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <dashboard-header :title="title" :path="path" />
        <!-- /Page Header -->

        <div class="row" v-if="!loader">
           <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link :to="`/employee`">
            <div class="card dash-widget">
              <div class="card-body">
                <span class="dash-widget-icon"><i class="fa-solid fa-user"></i></span>
                <div class="dash-widget-info">
                  <h3>{{usersData.length ?? 0}}</h3>
                  <span>Employees</span>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link :to="`/employee`">
            <div class="card dash-widget">
              <div class="card-body">
                <span class="dash-widget-icon"><i class="fa-solid fa-cubes"></i></span>
                <div class="dash-widget-info">
                  <h3>{{activeUsersCount}}</h3>
                  <span>Active User</span>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link :to="`/employee/fire-register-index`">
            <div class="card dash-widget">
              <div class="card-body">
                <span class="dash-widget-icon"
                  ><i class="fa-solid fa-check"></i
                ></span>
                <div class="dash-widget-info">
                  <h3>{{ memberOnSite.length ?? 0 }}</h3>
                  <span>Member On Site</span>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link :to="{path: '/employee/leaves', query: { pendingLeave: true }}">
            <div class="card dash-widget">
              <div class="card-body">
                <span class="dash-widget-icon"><i class="fa-solid fa-hourglass-start"></i></span>
                <div class="dash-widget-info">
                  <h3>{{ pendingLeavesCounts }}</h3>
                  <span>Pending Leaves</span>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link :to="{path: '/employee/leaves', query: { plannedLeave: true }}">
            <div class="card dash-widget">
              <div class="card-body">
                <span class="dash-widget-icon"><i class="fa-solid fa-bell"></i></span>
                <div class="dash-widget-info">
                  <h3>{{ plannedLeavesCounts }}</h3>
                  <span>Upcoming Leaves</span>
                </div>
              </div>
            </div>
            </router-link>
          </div>
           <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link :to="`/employee/pending-banked-time`">
            <div class="card dash-widget">
              <div class="card-body">
                <span class="dash-widget-icon"><i class="fa-solid fa-pencil"></i></span>
                <div class="dash-widget-info">
                  <h3>{{ pendingBankedTime }}</h3>
                  <span>Pending Banked Time</span>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link :to="`/employee/additional-shift-time`">
            <div class="card dash-widget">
              <div class="card-body">
                <span class="dash-widget-icon"><i class="fa-solid fa-clock"></i></span>
                <div class="dash-widget-info">
                  <h3>{{ pendingAdditonShift }}</h3>
                  <span>Pending Banked Shift</span>
                </div>
              </div>
            </div>
            </router-link>
          </div>
         
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-else>
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>

        <!-- <admin-charts></admin-charts> -->

        <!-- Statistics Widget -->
        <!-- <admin-statistics></admin-statistics> -->
        <!-- /Statistics Widget -->

        <!-- <div class="row">
          <div class="col-md-6 d-flex">
            <div class="card card-table flex-fill">
              <div class="card-header">
                <h3 class="card-title mb-0">Invoices</h3>
              </div>
              <div class="card-body">
                <admin-invoices></admin-invoices>
              </div>
              <div class="card-footer">
                <router-link to="/sales/invoices">View all invoices</router-link>
              </div>
            </div>
          </div>
          <div class="col-md-6 d-flex">
            <div class="card card-table flex-fill">
              <div class="card-header">
                <h3 class="card-title mb-0">Payments</h3>
              </div>
              <div class="card-body">
                <admin-payments></admin-payments>
              </div>
              <div class="card-footer">
                <router-link to="/sales/payments">View all payments</router-link>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-md-6 d-flex">
            <div class="card card-table flex-fill">
              <div class="card-header">
                <h3 class="card-title mb-0">Clients</h3>
              </div>
              <div class="card-body">
                <admin-clients></admin-clients>
              </div>
              <div class="card-footer">
                <router-link to="/clients">View all clients</router-link>
              </div>
            </div>
          </div>
          <div class="col-md-6 d-flex">
            <div class="card card-table flex-fill">
              <div class="card-header">
                <h3 class="card-title mb-0">Recent Projects</h3>
              </div>
              <div class="card-body">
                <admin-recent-project></admin-recent-project>
              </div>
              <div class="card-footer">
                <router-link to="/project/projects">View all projects</router-link>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- /Page Content -->
    </div>
</template>

<script>
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../../config";
import {dateRangeEnd, dateRangeStart} from "@/utils/util-var";
import {formatDDMMYYYY, formatUSDate} from "@/utils/util-funcitons";
export default {

  data() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    return {
      title: "Welcome "+userInfo.name,
      path: "Dashboard",
      usersData: [],
      userLeavesData: null,
       perPage:10,
      startDate:formatUSDate(dateRangeStart),
      endDate:formatUSDate(dateRangeEnd),
      employeeName:"",
      leaveType:null,
      leaveStatus:null,
      activeUsersCount:null,
      usersWithWorkingDay:null,
      present:null,
      memberOnSite:[],
      pendingLeavesCounts:null,
      plannedLeavesCounts:null,
      pendingBankedTime: null,
      pendingAdditonShift:null,
      loader:false
    };
  },
   mounted() {
    this.getUsers()
    this.userLeaves()
    this.getFireRegister()
    this.pendingBankedList()
    this.pendingAditionalShift()
  },

   methods: {

    async pendingBankedList() {

      await axios.post(`${VUE_APP_API_BASE_URL}/banked-time/pending-list?page=1`, { per_page: 1000 }).then((response) => {
        if (response.data.status) {
          this.pendingBankedTime = response.data.data.total;
        }
      }).catch(function (error) {
        console.log(error);
      })
        .finally(() => {
          
        });
    },

     async pendingAditionalShift() {

      await axios.post(`${VUE_APP_API_BASE_URL}/banked-time/get-non-banked-time-user-pending-list?page=1`, { per_page: 1000 }).then((response) => {
        if (response.data.status) {
          this.pendingAdditonShift = response.data.data.total;
        }
      }).catch(function (error) {
        console.log(error);
      })
        .finally(() => {
          this.loader = false;
        });
    },

    getFireRegister() {
      axios.post(`${VUE_APP_API_BASE_URL}/activity/get-fire-register`, {location_id: ''})
        .then((response) => {
          if (response.data.status) {
            this.memberOnSite = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {

        });
    },


    async getUsers() {
      this.loader = true;
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.usersData = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          
        });
    },
     async userLeaves(){
      await axios.get(`${VUE_APP_API_BASE_URL}/leave/all`,{
        params:{
          per_page:this.perPage,
          start_date:this.startDate,
          end_date:this.endDate,
          employee_name:this.employeeName,
          leave_type:this.leaveType,
          status:this.leaveStatus
        }
      }).then((response)=>{
        if(response.data.status){
          this.userLeavesData = response.data.data.leave_applications.data;
          this.activeUsersCount = response.data.data.active_users_count;
          this.usersWithWorkingDay = response.data.data.users_with_working_day;
          this.pendingLeavesCounts=response.data.data.pending_leaves;
          this.plannedLeavesCounts=response.data.data.upcoming_leaves_count;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
  
  }
};
</script>
